import { space } from 'folio-common-components';
import { listSum } from 'folio-common-utils';
import * as React from 'react';
import { type RootState, useActions, useSelector } from '../../state/';
import { type Owner, selectors } from '../../state/editor';
import { OwnerItem } from './OwnerItem';

export type { Owner, PersonOwner } from '../../state/editor';

interface Props {
  owners: Owner[];
  capital: number;
  assignEquity: (assignment: { id: string; equity: string }) => any;
  removeEquity: (id: string) => any;
}

const OwnerListItems: React.FC<Props> = props => {
  const { assignEquity, capital, owners, removeEquity } = props;
  const singleOwner = owners.length === 1;

  const offsetForItem = (index: number) => {
    return listSum(
      owners
        .slice(0, index)
        .filter(owner => owner.fraction <= 1)
        .map(owner => owner.fraction),
    );
  };

  const undistributedCapital = owners.reduce(
    (remainingCapital, owner) => remainingCapital - owner.equity,
    capital,
  );

  const forms = owners.map((owner, index) => {
    return (
      <form
        noValidate={true}
        key={owner.item.id}
        onSubmit={evt => {
          evt.preventDefault();
        }}
      >
        <OwnerItem
          owner={owner}
          singleOwner={singleOwner}
          undistributedCapital={undistributedCapital}
          onDelete={removeEquity}
          percentOffset={offsetForItem(index)}
          onOwnershipPercentageChange={percentage => {
            const capital = Number(owner.capital);
            const equity = `${Math.round((percentage / 100) * capital)}`;
            assignEquity({ id: owner.item.id, equity });
          }}
          onEquityChange={equity => assignEquity({ id: owner.item.id, equity })}
        />
      </form>
    );
  });
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{forms}</>;
};

function selector(state: RootState) {
  return {
    people: state.editor.people,
    owners: selectors.owners(state.editor),
    capital: Number(state.editor.coreInfo.capital) || 0,
  };
}

export const OwnerList: React.FC = () => {
  const selected = useSelector(selector);
  const { editorThunks } = useActions();

  const assignEquity = editorThunks.assignEquityAndMakeDirty;
  const removeEquity = editorThunks.removeOwnership;

  return selected.owners.length > 0 ? (
    <div css={space([16], 'margin-top')}>
      <OwnerListItems
        assignEquity={assignEquity}
        removeEquity={removeEquity}
        {...selected}
      />
    </div>
  ) : (
    <p>Ingen eiere lagt til ennå.</p>
  );
};
